import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

const NAV = [
  { to: '/entities/entity-tree', label: 'Entity Tree', testid: 'entity-nav-tree' },
  { to: '/entities/currencies', label: 'Currencies', testid: 'entity-nav-currencies' },
  { to: '/entities/fx-rates', label: 'FX Rates', testid: 'entity-nav-fx-rates' },
  { to: '/entities/intercompany', label: 'Intercompany', testid: 'entity-nav-intercompany' },
  { to: '/entities/consolidation', label: 'Consolidation', testid: 'entity-nav-consolidation' },
];

export default function EntitiesShell() {
  return (
    <div className="hr-shell" data-testid="entities-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Entities &amp; Consolidation</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
